import { render } from "./ProfileContainer.vue?vue&type=template&id=70f2d52c&scoped=true"
import script from "./ProfileContainer.vue?vue&type=script&lang=js"
export * from "./ProfileContainer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-70f2d52c"

export default script